import http from 'hub-http/clients/apiClient';

export default function defaultFetch(path: string, data: any) {
  return http.post(path, { data });
}
